import { getQuantityAllocationInventoryToTarget } from './getQuantityAllocationInventoryToTarget'
import { formatQuantitySubAllocationLineItems } from './formatQuantitySubAllocationLineItems'
import { formatQuantitySingleAllocationLineItem } from './formatQuantitySingleAllocationLineItem'

import { IS_SUB_ALLOCATION } from '../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

export const formatQuantityAllocationLineItems = ({ values, right, campaignId, currency }) => {
  const inventory = getQuantityAllocationInventoryToTarget(values, right)
  const isSubAllocation = right[IS_SUB_ALLOCATION]

  if (isSubAllocation) {
    return formatQuantitySubAllocationLineItems({
      inventory,
      values,
      right,
      campaignId,
      currency
    })
  } else {
    const lineItem = formatQuantitySingleAllocationLineItem({
      inventory,
      values,
      right,
      campaignId,
      currency
    })

    return [lineItem]
  }
}
